import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateCollarDTO } from "./type";
import type { Collar } from "@typings/entities/devices/collar";

export async function createCollar(collar: CreateCollarDTO): Promise<Collar> {
  const response = await apiClient.post<Collar>(
    apiPaths.devices.collars.create,
    collar,
  );
  return response.data;
}
